module.exports = __webpack_public_path__ + "static/media/legenda-bii.cf4b4d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/legenda-bii.png
// module id = 892
// module chunks = 0